import React, { Component } from 'react'
import PropTypes from 'prop-types'
import showDateTime from "../../../shared/ShowDateTime"

class HistoryRow extends Component {
    render() {
        const { history, index } = this.props
        const { created_at, description, meta, IP, action } = history
        const { printer, presser, batch_detail = {}, updated_by, actor = '', rule = {} } = meta
        const { receive_sew_name = '' } = { ...batch_detail }
        const { name: ruleName } = rule || {}

        return (
            <tr className="HistoryRow">
                <td className="colID">{index + 1}</td>
                <td className="colTime">{showDateTime(created_at)}</td>
                <td className="colDescription">
                    {
                        !!receive_sew_name && ['UPDATED_STATUS_RECEIVE_SEW'].includes(action) ?
                            `${description} Người nhận may: ${receive_sew_name}` :
                            description || '-'
                    }

                    {
                        meta.hasOwnProperty('sub_id') &&
                        <span> tới lô con <a rel="noopener noreferrer" target='_blank'
                            href={`/batches/${meta.sub_id}`}>{meta.sub_name}</a>
                        </span>
                    }
                </td>
                <td className="colActor">
                    {!!(actor || updated_by) &&
                        <span className='mx-1'>{actor || updated_by || ''}</span>
                    }
                    {!actor && !updated_by && !ruleName ? '-' : ''}
                    {!!ruleName &&
                        <span className='mx-1'>Auto - Rule: <span className="font-weight-bold">{ruleName}</span></span>
                    }
                </td>
                <td className="colPrinterName">{printer || '-'}</td>
                <td className="colPresserrName">{presser || '-'}</td>
                <td className="colIP">{IP || '-'}</td>
                <td className="colKey"><code>{action || '-'}</code></td>
            </tr>
        )
    }
}

HistoryRow.propTypes = {
    history: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
}

export default HistoryRow